import styled from "@emotion/styled"
import colors from "theme/colors"
import { NewText } from "ui"
import PazomatForm from "./PazomatForm"

const StyledFormDiv = styled.div`
  display: flex;
  flex-direction: column;
  background: rgba(236, 240, 243, 1);
  border-radius: 12px;
  height: 500px;
  padding: 20px 20px 0 20px;
  margin-top: 20px;
  ${(props) => props.theme.breakpoints.up("md")} {
    padding: 13px 14px 0px 14px;
    margin-top: 0px;
    height: 450px;
  }

  ${(props) => props.theme.breakpoints.up("lg")} {
    height: 602px;
    padding: 20px 20px 24px 28px;
  }
`

function JoinForm() {
  return (
    <StyledFormDiv>
      <NewText
        largeDesktopFontSize={28}
        largeDesktopLineHeight="35.84px"
        mobileFontSize={24}
        desktopFontWeight={500}
        component={"p"}
        color={colors.blue}
        desktopFontSize={18}
        desktopLineHeight="23px"
      >
        רוצה לשמוע עוד על פזומט?
      </NewText>
      <PazomatForm />
    </StyledFormDiv>
  )
}

export default JoinForm
